import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'

import { Table } from "reactstrap";

const mapStateToProps = (state) => {

    return {
        getReglaNegocioDetail: state.ReglaNegocioReducer.getReglaNegocioDetail,
    };
    
}; //END MAPSTATETOPROPS

class ReglaNegocioDelete extends Component {


    render() {
        let isEmpty         = this.props.getReglaNegocioDetail.length === 0;
        let reglanegocio    = Object.values(this.props.getReglaNegocioDetail);

        return (
            <form onSubmit={this.props.handleSubmit}>
                <FormGroup row>
                    <Col md="12">
                        <FormGroup>

                            <Table striped>
                                <tbody>


                                    {isEmpty ?
                                        <div>There are no results</div>
                                        :
                                        reglanegocio.map(item =>
                                            <>
                                                <tr>
                                                    <td width="200">ID</td>
                                                    <td width="10">:</td>
                                                    <td>{item.idreglanegocio}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Nombre</td>
                                                    <td width="10">:</td>
                                                    <td>{item.nombre}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Descripción</td>
                                                    <td width="10">:</td>
                                                    <td>{item.descripcion}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Tipo</td>
                                                    <td width="10">:</td>
                                                    <td>{item.tipo}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Valor</td>
                                                    <td width="10">:</td>
                                                    <td>{item.valor}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Operación</td>
                                                    <td width="10">:</td>
                                                    <td>{item.operacion}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Asignación</td>
                                                    <td width="10">:</td>
                                                    <td>{item.asignar}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Activo</td>
                                                    <td width="10">:</td>
                                                    <td>{(item.activo ? "SI" : "NO")}</td>
                                                </tr>

                                                <tr>
                                                    <td width="200">Fecha Alta</td>
                                                    <td width="10">:</td>
                                                    <td>{item.fechaalta}</td>
                                                </tr>
                                            </>
                                        )
                                    }

                                </tbody>
                            </Table>


                        </FormGroup>
                    </Col>
                </FormGroup>


                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            {
                                !this.props.submitSucceeded ? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ) : (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )

                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

ReglaNegocioDelete = reduxForm({
    form: "formReglaNegocioDelete",
    enableReinitialize: true,
})(ReglaNegocioDelete);
export default connect(mapStateToProps, null)(ReglaNegocioDelete);
